import { Tables } from "@/lib/supabase/supabase_types_override";
import { useUserStore } from "@/lib/zustand/useStore";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { addResponse, deleteInvalidatedResponses, UseAddResponseProps } from ".";
import { getQuestionsInvalidatedByResponse } from "@/features/question/utils/findDependentQuestions";
import { groupInvalidatedQuestions } from "@/features/question/utils/groupInvalidatedQuestions";
import { queryKeys } from "@/lib/useQuery/queryKeys";
import { QuestionWithDependents } from "@/features/question/hooks/useQuery/useGetQuestionsBySurveyId";

export function useAddResponse() {
    const userStore = useUserStore();
    const queryClient = useQueryClient()

    return useMutation({
        mutationKey: queryKeys.response._def,
        mutationFn: async ({
            questions,
            questionId,
            response,
        }: UseAddResponseProps) => {
            const res = await addResponse(questionId, response.response, response.additional ?? null, userStore!.id!);
            if (res.error) {
                console.error(res.error)
                throw new Error(res.error.message);
            }
            const questionsThatWillBeInvalid = getQuestionsInvalidatedByResponse(
                questionId,
                String(response.additional),
                questions ?? [],
                userStore?.id ?? 'mock-user-id',
            );
            const groupedQuestions = groupInvalidatedQuestions(questionsThatWillBeInvalid, questions ?? []);
            let deleteResponsesForQuestionsWithIds: Tables<'question'>['id'][] = []
            const recursiveGetQuestionId = (questions: QuestionWithDependents[]) => {
                questions.forEach(question => {
                    deleteResponsesForQuestionsWithIds.push(question.id);
                    console.log(question.question)
                    console.log(question.id)
                    if (question.dependent_questions && question.dependent_questions.length > 0) {
                        recursiveGetQuestionId(question.dependent_questions);
                    }
                });
            }
            recursiveGetQuestionId(groupedQuestions);
            deleteResponsesForQuestionsWithIds = deleteResponsesForQuestionsWithIds.filter(
                q => q !== questionId
            )
            if (deleteResponsesForQuestionsWithIds.length > 0) {
                const deleteResponsePromises = deleteResponsesForQuestionsWithIds.map((questionId) => {
                    return deleteInvalidatedResponses(questionId, userStore!.id!);
                });
                await Promise.all(deleteResponsePromises);
            }
        },
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: queryKeys.question._def, exact: false })
        }
    })
}